import * as React from 'react';
import { Grid, Button, Alert, ProgressBar } from '../../common';
import UserLookup from '../../common/form-controls/Lookups/UserLookup';
import { useEffect, useState } from 'react';
import UserLookupObject from '../../../models/UserLookupObject';
import TemporaryAccessPasswordService from '../../../services/TemporaryAccessPasswordService';
import { AlertBanner } from '../../../models/interfaces/AlertBanner';
import StandardModal from '../../common/modals/StandardModal';

interface TAPModalDelegationProps {
	visible: boolean;
	setVisible: any;
	tapService: TemporaryAccessPasswordService;
	refreshTap: any;
}

const TAPModalDelegation = ({ visible, setVisible, tapService, refreshTap }: TAPModalDelegationProps) => {
	const [delegatedUser, setDelegatedUser] = useState<UserLookupObject>();
	const [tapUser, setTapUser] = useState<UserLookupObject>();
	const [enableRequestButton, setEnableRequestButton] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isVerifyingSup, setIsVerifyingSup] = useState<boolean>(false);
	const [tap, settap] = useState<string>('');
	const [alertBanner, setAlertBanner] = useState<AlertBanner>({
		visible: false,
		variant: 'default',
	});

	useEffect(() => {
		settap('');
		enableRequest();
	}, [tapUser]);

	const handleCloseAlert = () => {
		setAlertBanner({ visible: false, variant: 'default' });
	};

	const handleRequest = async () => {
		try {
			setIsLoading(true);
			const response = await tapService.submitTapOnBehafDelegated(delegatedUser.id, tapUser.id);
			settap(response.delegated.displayName);
			if (response != null) {
				setEnableRequestButton(false);
				setAlertBanner({
					visible: true,
					text: `TAP Delegated succesfully created`,
					variant: 'success',
				});
			} else {
				setAlertBanner({
					visible: true,
					text: `TAP could not be generated, please try again or submit a feedback for getting assistance`,
					variant: 'error',
				});
			}
			setIsLoading(false);
		} catch (err) {
			setIsLoading(false);
			settap('');
			setAlertBanner({
				visible: true,
				text: err.response.data.message,
				variant: 'error',
			});
		}
	};

	const handleClose = async () => {
		if (tap != '') {
			refreshTap(true);
		}
		setVisible(false);
	};

	//Validates if requestor is the supervisor of the selected employee
	const enableRequest = async () => {
		try {
			if (tapUser) {
				setIsVerifyingSup(true);
				await tapService.getSupVerifycation(tapUser.userPrincipalName);
				setIsVerifyingSup(false);
				setEnableRequestButton(true);
			} else {
				setEnableRequestButton(false);
				setIsVerifyingSup(false);
			}
		} catch (err) {
			setEnableRequestButton(false);
			setIsVerifyingSup(false);
			setAlertBanner({ visible: true, text: err.response.data.message, variant: 'error' });
		}
	};

	return (
		<StandardModal
			show={visible}
			onDismiss={() => setVisible(false)}
			title="Delegate TAP request"
			footer={
				<Grid variant="2up">
					<Grid.Item>
						<Button variant="secondary" onClick={() => handleClose()} disabled={isLoading}>
							Close
						</Button>
					</Grid.Item>
					<Grid.Item>
						<Button
							variant="primary"
							onClick={() => handleRequest()}
							disabled={!enableRequestButton || isLoading || isVerifyingSup}
						>
							{isLoading || isVerifyingSup ? 'Loading...' : 'Request'}
						</Button>
					</Grid.Item>
				</Grid>
			}
		>
			{isLoading || isVerifyingSup ? (
				<ProgressBar
					className="em-u-margin-top-half"
					indeterminate
					label={isLoading ? 'Getting TAP' : 'Verifying Supervisor'}
				/>
			) : (
				<>
					<UserLookup
						id="employee-lookup"
						label="On Behalf Of:"
						note={'You must be the Supervisor of the selected employee'}
						value={tapUser?.displayName}
						onChange={(value) => setTapUser(value)}
					/>
					{alertBanner.visible && (
						<Alert
							variant={alertBanner.variant}
							onClose={handleCloseAlert}
							style={{ margin: '1rem 0' }}
							body={alertBanner.text}
						/>
					)}
					<UserLookup
						id="delegated-user-lookup"
						label="Delegated User:"
						note={'Select the employee to delegate TAP request'}
						value={delegatedUser?.displayName}
						onChange={(value) => setDelegatedUser(value)}
					/>
				</>
			)}
			<Alert
				variant="warning"
				style={{ margin: '0' }}
				body="Delegations will be valid for 7 days, after which point, they will automatically expire. If the supervisor needs to change the delegate for a particular user, they can cancel the request and submit a new one."
			/>
		</StandardModal>
	);
};

export default TAPModalDelegation;
